import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from './TrialBanner.module.css';
import Icon from '../common/Icon';

// Countdown pill shown in the TopBar for accounts on the "Trial" plan
// (me.trialEndsAt is non-null only for them). Re-renders every minute so the
// remaining time stays honest without a page reload.
const TrialBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!user?.trialEndsAt) return;
    const id = window.setInterval(() => setTick((t) => t + 1), 60_000);
    return () => window.clearInterval(id);
  }, [user?.trialEndsAt]);

  if (!user?.trialEndsAt) return null;

  const planLabel = user.planName || 'Trial';
  const msLeft = new Date(user.trialEndsAt).getTime() - Date.now();
  const expired = msLeft <= 0;
  const daysLeft = Math.floor(msLeft / 86_400_000);
  const hoursLeft = Math.floor((msLeft % 86_400_000) / 3_600_000);
  const remaining = daysLeft >= 1
    ? `${daysLeft} day${daysLeft === 1 ? '' : 's'} left`
    : hoursLeft >= 1
      ? `${hoursLeft} hour${hoursLeft === 1 ? '' : 's'} left`
      : 'less than an hour left';

  return (
    <div className={`${styles.banner} ${expired ? styles.expired : ''}`}>
      <Icon name={expired ? 'lock_clock' : 'hourglass_top'} className="text-base" />
      <span className={styles.text}>
        {expired
          ? `${planLabel} expired`
          : <>{planLabel} · {remaining} <span className={styles.until}>(until {new Date(user.trialEndsAt).toLocaleDateString()})</span></>}
      </span>
      {/* A subuser's plan is its main user's to change. */}
      {!user.isSubuser && (
        <button className={styles.upgradeBtn} onClick={() => navigate('/upgrade')}>
          Upgrade
        </button>
      )}
    </div>
  );
};

export default TrialBanner;
